export function readableForeground(background: string): '#000000' | '#FFFFFF' {
  if (!/^#[0-9A-Fa-f]{6}$/.test(background)) return '#FFFFFF';

  const channels = [1, 3, 5].map(
    (index) => Number.parseInt(background.slice(index, index + 2), 16) / 255,
  );
  const linear = channels.map((channel) => (
    channel <= 0.04045
      ? channel / 12.92
      : ((channel + 0.055) / 1.055) ** 2.4
  ));
  const luminance = (
    0.2126 * (linear[0] ?? 0)
    + 0.7152 * (linear[1] ?? 0)
    + 0.0722 * (linear[2] ?? 0)
  );
  const whiteContrast = 1.05 / (luminance + 0.05);
  const blackContrast = (luminance + 0.05) / 0.05;

  return blackContrast > whiteContrast ? '#000000' : '#FFFFFF';
}
